import { render, staticRenderFns } from "./editJuisd.vue?vue&type=template&id=097e94aa&scoped=true"
import script from "./editJuisd.vue?vue&type=script&lang=js"
export * from "./editJuisd.vue?vue&type=script&lang=js"
import style0 from "./editJuisd.vue?vue&type=style&index=0&id=097e94aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097e94aa",
  null
  
)

export default component.exports